// Mapper: transport LC_GetMyTeamMonthlyTardinessSummaryOut → domain model for the
// "Mi equipo" dashboard "Resumen del mes" — "Atrasos" card (ASIS-5410 / REXASIS-009).
// The backend only sends the raw hours; the percentage/isEmpty business rules are
// computed here so the UI never re-implements them.
//
// totalHours (calculated, caHistoricoLibroAsistenciaDet) and approvedHours (justified,
// caHorasAtrasosJustificadas) come from different subsystems, so approved <= total is not
// guaranteed — the backend already clamps pendingHours to 0 for the same reason. percentage
// is clamped to 100 here to match, and isEmpty requires both to be 0 so a mismatch (e.g.
// total=0 with approved>0) never renders as the empty state.

import type {
  LC_GetMyTeamMonthlyTardinessSummaryOut,
  MyTeamMonthlyTardinessSummary,
} from '../types/myTeamMonthlyTardinessSummary.types';


export function mapMyTeamMonthlyTardinessSummary(
  out: LC_GetMyTeamMonthlyTardinessSummaryOut,
): MyTeamMonthlyTardinessSummary {
  const isEmpty = out.totalHours === 0 && out.approvedHours === 0;
  const percentage = isEmpty
    ? 0
    : Math.min(100, Math.round((out.approvedHours / out.totalHours) * 100));

  return {
    totalHours: out.totalHours,
    approvedHours: out.approvedHours,
    pendingHours: out.pendingHours,
    percentage,
    isEmpty,
  };
}
